import { render } from "./terminal.vue?vue&type=template&id=0cc7f1d4&scoped=true"
import script from "./terminal.vue?vue&type=script&lang=js"
export * from "./terminal.vue?vue&type=script&lang=js"

import "./terminal.vue?vue&type=style&index=0&id=0cc7f1d4&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc7f1d4"]])

export default __exports__